import { appLocalStorage } from '@/app/shared/commonURLs';

let OutpatientUrl = appLocalStorage.OutpatientUrl;
let OutpatientODataUrl = appLocalStorage.OutpatientODataUrl;
let BillingServiceUrl = appLocalStorage.BillingServiceUrl;
let VisitManagementServiceUrl = appLocalStorage.VisitManagementServiceUrl ;
// Need to be removed when adding medical setup module to the project
let MedicalSetupURL = appLocalStorage.MedicalsetupUrl;
let MedicalSetupOdataUrl = appLocalStorage.MedicalsetupOdataUrl;

export class uRls {
    constructor() {
        this.OutPatientServiceList = OutpatientURLs();
    }
}

const OutpatientURL = new uRls();
export { OutpatientURL };


function OutpatientURLs() {

    var services = {};
    //================ Start Housing Module Services ======================
    services["getClinicSchedulerData"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/getClinicSchedulerData',
    }

    services["GetInitAddHousing"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/GetInitAddHousing',
    }
    services["GetClinicAllowHousingDays"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/GetClinicAllowHousingDays',
    }
    services["CheckAvailableRooms"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Housing/CheckAvailableRooms',
    }

    services["CheckRoomHousing"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Housing/CheckRoomHousing',
    }

    services["Add"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Housing/Add',
    }

    services["GetUnassignedClincsByBuildingID"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/GetUnassignedClincsByBuildingID',
    }

    services["GetClincInfoByID"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/GetClincInfoByID',
    }

    services["GetEditHousingView"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/GetEditHousingView',
    }

    services["Edit"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Housing/Edit',
    }

    services["Delete"] = {
        Method: 'Delete',
        URL: OutpatientUrl + 'Housing/Delete',
    }

    services["DeleteHousingList"] = {
        Method: 'Get',
        URL: OutpatientUrl + 'Housing/DeleteHousingList',
    }
    //================ End Housing Module Services ======================
    //___________________________________________________________________________________________

    //================ Start Clinic Tag List Module Services ===============

    services["ClinicTagOData"] = {
        Method: 'Get',
        URL: OutpatientODataUrl + 'ClinicTagOData?',
    }
    services["AddClinicTag"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'ClinicTag/AddClinicTag',
    }; 
    services["UpdateClinicTag"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'ClinicTag/UpdateClinicTag',
    };
    services["DeleteClinicTag"] = {
        Method: 'DELETE',
        URL: OutpatientUrl + 'ClinicTag/DeleteClinicTag',
    };
    //================ End Clinic Tag List Module Services ======================
 
    //___________________________________________________________________________________________

    //================ Start Clinic Tag List Module Services ===============
    services["getAllSupervisoryLevel"] = {
        Method: 'GET',
        URL: MedicalSetupURL + 'SupervisoryLevel/getAllSupervisoryLevel',
    }
    services["getPhysiciansMainData"] = {
        Method: 'GET',
        URL: MedicalSetupOdataUrl + 'PhysicianDummyOData?',
    } 

    services["SearchClinicTagPattern"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'TestingBookingDummy/SearchClinicTagPattern',
    }
    
    //================ End Clinic Tag List Module Services ======================



    //Get Appointments Related To Specific Patient
    services["GetAppointmentsRelatedToSpecificPatient"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetRelatedToSpecificPatient',
    }

    //Start Appointments Booking Popup Services
    services["GetAllBussinessSource"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'BusinessSource/GetAllBussinessSource',
    };
    services["GetPatternDividedCapacity"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'PatternSlots/GetPatternDividedCapacity',
    };
    services["GetVisitTypesRelatedVisitType"] = {
        Method: 'GET',
        URL: VisitManagementServiceUrl + 'VisitManagement/OutpatientRecommendedVisitTypes',
    };
    services["GetPatternConsultationType"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Pattern/GetPatternConsultationType',
    };
    //insured
    services["GetAppointmentConsultationTypes"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetAppointmentConsultationTypes',
    };
    services["GetBillingContractFields"] = {
        Method: 'GET',
        URL: BillingServiceUrl + 'BillingLookup/GetNoEntityBillingLKP',
    };
    services["GetRequiredContractorClientConfiguration"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetRequiredContractorClientConfiguration',
    };
    services["GetPatientLastFinancialStatus"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'AppointmentBilling/GetPatientLastFinancialStatus',
    };
    services["GetBillingContracts"] = {
        Method: 'GET',
        URL: BillingServiceUrl + 'BillingLookup/GetContracts',
    };

    //new client   
    services["AddClientToSpecificContractor"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'AppointmentBilling/AddClientToSpecificContractor',
    };
    services["GetBillingContractClients"] = {
        Method: 'GET',
        URL: BillingServiceUrl + 'BillingLookup/GetNoEntityContractorClientsList',
    };
    services["PriceInquiry"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'AppointmentBilling/PriceInquiry',
    };
    services["BookAnAppointment"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Appointment/BookAnAppointment',
    };
    //End Appointments Booking Popup Services
    services["GetClinicTagViewPatterns"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'PatternSlots/GetClinicTagViewPatterns',
    }
    services["GetPhysiciansSlots"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'PatternSlots/GetPhysicianSlots',
    } 
    services["GetAvailableSlots"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'PatternSlots/GetAvailableSlots',
    } 
    
    services["GetAnAppointment"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetAnAppointment',
    };
    //cancel appointment
    services["GetAppointmentCancelActiveReasons"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetAppointmentCancelActiveReasons',
    };
    services["CancelAppointment"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/CancelAppointment',
    };
    services["PasteAppointment"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Appointment/PasteAnAppointment',
    } 
    services["GetNeedRescheduleByPhysicians"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetNeedRescheduleByPhysicians',
    } 
    services["MergeSlot"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Slot/MergeSlot',
    } 
    services["UnmergeSlot"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Slot/UnmergeSlot',
    } 
    services["ForcedOverbookSlot"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Slot/ForcedOverbookSlot',
    } 
    services["OverbookSlot"] = {
        Method: 'POST',
        URL: OutpatientUrl + 'Slot/OverbookSlot',
    } 

    services["GetReschedulePhysiciansList"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Booking/GetNeedReschedulePhysiciansList',
    } 

    services["GetPhysiciansWithSamePhysicianSpeciality"] = {
        Method: 'GET',
        URL: OutpatientUrl + 'Appointment/GetPhysiciansWithSamePhysicianSpeciality',
    }  

    
    return services
}

